// ============================================================
// BASIC DATE HELPERS
// ============================================================

export function toDate(value) {
  if (!value) return null

  return value instanceof Date
    ? value
    : new Date(value)
}

export function formatDate(date) {
  if (!date) return null

  const d =
    date instanceof Date
      ? date
      : new Date(date)

  return d.toISOString().split('T')[0]
}

export function startOfDay(date) {
  const d = toDate(date)

  if (!d) return null

  const result = new Date(d)

  result.setHours(0, 0, 0, 0)

  return result
}



// ============================================================
// OPERATIONAL DAY
// ============================================================

export function getOperationalDate(
  timezone = 'UTC',
  operationalDayStart = 4
) {

  const now = new Date()

  // Convert to user's timezone
  const localized = new Date(
    now.toLocaleString(
      'en-US',
      { timeZone: timezone }
    )
  )

  // If before operational start hour,
  // treat as previous day
  if (
    localized.getHours() <
    operationalDayStart
  ) {
    localized.setDate(
      localized.getDate() - 1
    )
  }

  return startOfDay(localized)
}


// ============================================================
// DATE MATH
// ============================================================

export function isSameOrAfter(dateA, dateB) {
  const a = startOfDay(dateA)
  const b = startOfDay(dateB)

  if (!a || !b) return false

  return a.getTime() >= b.getTime()
}

export function addDays(date, days) {
  const d = startOfDay(date)

  const result = new Date(d)

  result.setDate(
    result.getDate() + days
  )

  return result
}

export function addWeeks(date, weeks) {
  return addDays(date, weeks * 7)
}

export function addMonths(date, months) {
  const d = startOfDay(date)

  const result = new Date(d)

  result.setMonth(
    result.getMonth() + months
  )

  return result
}

export function addYears(date, years) {
  const d = startOfDay(date)

  const result = new Date(d)

  result.setFullYear(
    result.getFullYear() + years
  )

  return result
}

export function addInterval(
  date,
  value = 1,
  unit = 'days'
) {

  switch (unit) {

    case 'days':
      return addDays(date, value)

    case 'weeks':
      return addWeeks(date, value)

    case 'months':
      return addMonths(date, value)

    case 'years':
      return addYears(date, value)

    default:
      return addDays(date, value)
  }
}

// ============================================================
// FRIENDLY DISPLAY
// ============================================================

export function formatFriendlyDate(dateString) {

  if (!dateString) return null

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const date = new Date(dateString)
  date.setHours(0, 0, 0, 0)

  const diffDays =
    Math.round((date - today) / (1000 * 60 * 60 * 24))

  if (diffDays === 0) return 'Today'

  if (diffDays === 1) return 'Tomorrow'

  if (diffDays === -1) return 'Yesterday'

  if (diffDays > 1 && diffDays < 7) {
    return date.toLocaleDateString('en-US', {
      weekday: 'long'
    })
  }

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  })

}